<script lang="ts">
	import { CleanHTML } from '@tools/CleanHTML';

	let { text }: { text: string } = $props();
</script>

<!-- eslint-disable-next-line svelte/no-at-html-tags -->
{@html CleanHTML(text)}
